/* eslint-disable consistent-return */

// import styled from 'styled-components';
import Grid from '@material-ui/core/Grid'
import { withStyles } from '@material-ui/core/styles'
/**
 *
 * DetailWithStatusBar
 *
 */
import React from 'react'
import StatusData from './fixture.json'
import StatusBox from './StatusBox'

const styles = theme => ({
  root: {
    fontSize: theme.typography.fontSizeSm,
    fontWeight: theme.typography.fontWeightBolder,
    color: `var(--gameday-body-textColorAlt, ${theme.body.textColorAlt})`,
    '& .obtained': {
      fontSize: theme.typography.fontSizeXLg,
    },
    '& .outOf': {
      padding: '0 0 10px',
    },
  },
})

class DetailWithStatusBar extends React.Component {
  static defaultProps = {
    obtained: 0,
    outff: 1,
    title: 'Results and Records...',
    StatusData,
  }

  static throwError() {
    // eslint-disable-next-line prefer-rest-params
    // biome-ignore lint/complexity/noArguments: TODO
    return new Error(...arguments)
  }

  render() {
    const { className, classes, ...rest } = this.props
    return (
      <div className={classes.root} {...rest}>
        <Grid container spacing={24}>
          {/* biome-ignore lint/complexity/useOptionalChain: TODO */}
          {StatusData &&
            StatusData.map((item, key) => (
              // eslint-disable-next-line react/no-array-index-key
              <Grid
                key={`item${
                  // biome-ignore lint/suspicious/noArrayIndexKey: TODO
                  key
                }`}
                item
                xs={12}
                sm={6}
                md={3}
              >
                <StatusBox
                  title={item.title}
                  obtained={item.obtained}
                  outOff={item.outOff}
                  colorStart={item.colorStart}
                  colorMid={item.colorMid}
                  colorSuccess={item.colorSuccess}
                />
              </Grid>
            ))}
        </Grid>
      </div>
    )
  }
}

export default withStyles(styles)(DetailWithStatusBar)
